import React, { useEffect, useState } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { useNavigate } from 'react-router-dom';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Card, CardBody, CardTitle } from 'reactstrap';
import { toast } from 'react-toastify';
import { LiaAngleDoubleUpSolid } from 'react-icons/lia';
import '../styles/floatingForm.css'
import gsap from 'gsap';

const CreateUpdatePage = ({setShowCreatePage, containerRef, pageId, setPageId, pageName, setPageName}) => {
    const [errors, setErrors] = useState({});
  
  
    const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};

    if (!pageName.trim()) errors.pageName = 'Page Name cannot be empty';

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setErrors({});

    try {
      if (pageId) {
        // Update existing page
        const response = await api.post(`/page/update/${pageId}`, { name: pageName });
        if (response.data.status === "success") {
          toast.success(`Page updated successfully!`);
          setPageId(null);
          handleCancel()
        } else {
          toast.error('Failed to update page');
        }
      } else {
        // Create new page
        const response = await api.post('/page/add', { name: pageName });
        if (response.data.status === "success") {
          toast.success(`Page created successfully!`);
          handleCancel()

        } else {
          toast.error('Failed to create page');
        }
      }
      setPageName('');
    } catch (error) {
      console.error('Error saving page:', error);
      alert('Error saving page');
    }
  };

  function handleCancel(){
     if (containerRef.current) {
        gsap.to(containerRef.current, {
            autoAlpha: 0,
            y: 50,
            duration: 0.4,
            ease: "power2.in",
            onComplete: () =>    setShowCreatePage(false),
        });
        } else {
            setShowCreatePage(false);
        }
  }


  return (
    <div className='floating-form-container smaller' ref={containerRef} >
      <div className="heading">
        <h2>Page Details </h2>
      </div>

        <form onSubmit={handleSubmit}>
            <div className="form-container">

                <div className="section-1">

                    <div className="input-container-floating-form wid-100">
                        <label htmlFor='vendor'>Page Name *</label>
                        <input type="text" className={`form-control ${errors.pageName ? 'is-invalid' : ''}`} value={pageName} onChange={(e) => setPageName(e.target.value)} />
                    <b>{errors.pageName && <span className='text-danger small'>{errors.pageName}</span>}</b>
                    </div>

                </div>


            </div>

            <div className="form-btn-container">

                <button type='submit'>{pageId ? 'Update' : 'Create'}</button>
                <button type='reset' onClick={handleCancel}>Cancel</button>

            </div>


        </form>

    </div>
  );
};

export default CreateUpdatePage;
